import Vue from "vue";
import * as firebase from "firebase";
import VueRouter from "vue-router";

import App from "./App.vue";
import routes from "./routes";
import store from "./store";

Vue.config.productionTip = false;

Vue.use(VueRouter);

const router = new VueRouter({ routes });
const firebaseConfig = {
  apiKey: "AIzaSyD_24JK8UuYJcHVRP6gvkGeK-YtFSiuP28",
  authDomain: "offclub-sellers.firebaseapp.com",
  databaseURL: "https://offclub-sellers.firebaseio.com",
  projectId: "offclub-sellers",
  storageBucket: "offclub-sellers.appspot.com",
  messagingSenderId: "271457014816",
  appId: "1:271457014816:web:339d93773c7a7ca3b01845"
};

firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
